/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AccountData = {
  accountDiscount?: InputMaybe<AccountDiscount>;
  credit?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  newCustomer: Scalars['Boolean']['input'];
};

export type AccountDiscount = {
  active: Scalars['Boolean']['input'];
  amount: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  d1MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  d2MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  freeShipping: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  lockedAt?: InputMaybe<Scalars['String']['input']>;
  maxRedemptionsPerEmail?: InputMaybe<Scalars['Int']['input']>;
  newCustomerOnly: Scalars['Boolean']['input'];
  tenantId: Scalars['Int']['input'];
  totalMealMinimum?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  weeksToApply?: InputMaybe<Scalars['Int']['input']>;
};

export type AddVariantToCartDeliveryInput = {
  quantity: Scalars['Int']['input'];
  /** ID of the Variant in the ecomm-catalog-service */
  variantId: Scalars['Int']['input'];
};

export type ApplePayV2 = {
  __typename?: 'ApplePayV2';
  displayName: Scalars['String']['output'];
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  /** The payment process network (e.g. Visa, MasterCard) */
  network: Scalars['String']['output'];
};

export type Cart = {
  __typename?: 'Cart';
  appliedCodeType?: Maybe<Scalars['String']['output']>;
  cartDeliveries: Array<CartDelivery>;
  cartError?: Maybe<CartError>;
  cartLedger?: Maybe<CartLedger>;
  createdAt: Scalars['DateTime']['output'];
  createdFromPersonalizedPlan: Scalars['Boolean']['output'];
  createdFromPlan?: Maybe<Plan>;
  customizeBy?: Maybe<Scalars['DateTime']['output']>;
  deliveryDates: Scalars['JSON']['output'];
  deliveryWeek: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  discountErrors?: Maybe<Array<Scalars['String']['output']>>;
  funnelData: Scalars['JSON']['output'];
  legacyOrderId?: Maybe<Scalars['Float']['output']>;
  mealSize: MealSize;
  metroId: Scalars['Int']['output'];
  modifiedDuringFunnel: Scalars['Boolean']['output'];
  orderOn?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<CartPaymentMethodV2>;
  recipientName: Scalars['String']['output'];
  recipientId?: Maybe<Scalars['Int']['output']>;
  status: CartStatus;
  subscription?: Maybe<SubscriptionEntityV2>;
  tenantEligibilityConfigLogicalId: Scalars['String']['output'];
  tenantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};


export type CartCartLedgerArgs = {
  previewDiscountCode?: InputMaybe<Scalars['String']['input']>;
  previewFunnelDiscountCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartDataInternalInput = {
  legacyOrderId: Scalars['Int']['input'];
  orderOn?: InputMaybe<Scalars['Date']['input']>;
  planLogicalId?: InputMaybe<Scalars['String']['input']>;
  populationCriteria?: InputMaybe<CartPopulationCriteriaInput>;
  /** Captures all used query params on cart creation */
  queryParams?: InputMaybe<Scalars['JSON']['input']>;
  recipientName: Scalars['String']['input'];
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a delivery of products */
export type CartDelivery = {
  __typename?: 'CartDelivery';
  cart: Cart;
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['Date']['output'];
  deliveryType: Scalars['Int']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  estimatedTransitTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lineItems: Array<CartDeliveryLineItem>;
  location?: Maybe<CartLocationV2>;
  /** This should reference a location object associated with the customer */
  locationId?: Maybe<Scalars['Int']['output']>;
  orderDelivery?: Maybe<OrderDelivery>;
  status: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CartDeliveryInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItems: Array<CartLineItemInput>;
};

export type CartDeliveryLineItem = {
  __typename?: 'CartDeliveryLineItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Catalog variant data pulled from cache or ecomm-catalogs */
  variant?: Maybe<Scalars['JSON']['output']>;
  variantId: Scalars['Int']['output'];
};

export type CartDeliveryResult = CartDelivery | CartError;

export type CartError = {
  __typename?: 'CartError';
  validation?: Maybe<CartValidation>;
};

export type CartLedger = {
  __typename?: 'CartLedger';
  creditTotal: Scalars['Int']['output'];
  deliveryTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  precreditTotal: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
};

export type CartLineItemInput = {
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type CartLocationV2 = {
  __typename?: 'CartLocationV2';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  dropoffLocation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type CartPaymentMethodV2 = ApplePayV2 | CreditCardV2 | PayPalV2;

export type CartPopulationCriteriaInput = {
  ingredientToAvoidIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  mealQuantity?: InputMaybe<Scalars['Float']['input']>;
  mealQuantityByMealType?: InputMaybe<MealQuantityByMealTypeInput>;
  nutritionalFacts?: InputMaybe<NutritionalFactsInput>;
  tagIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CartResult = Cart | CartError;

export enum CartStatus {
  /** The cart has been canceled. At time of writing, this only occurs when a user cancels their own cart, for something like skipping a week. */
  Canceled = 'CANCELED',
  /** The cart failed processing. This is most commonly caused by payment failure but can also be caused by internal errors. */
  FailedProcessing = 'FAILED_PROCESSING',
  /** The cart has been created but is not yet eligible for processing. */
  Initialized = 'INITIALIZED',
  /** The cart is eligible for processing but has not yet been processed. Payment has not yet been collected and fulfillment artifacts have not been created. */
  PendingProcessing = 'PENDING_PROCESSING',
  /** The cart was successfully processed. Payment has been collected and fulfillment artifacts have been generated. */
  Processed = 'PROCESSED',
  /** The cart is being processed and can no longer be modified. */
  Processing = 'PROCESSING',
  /** The cart has been queued for processing and can no longer be modified. */
  Queued = 'QUEUED'
}

export type CartValidation = {
  __typename?: 'CartValidation';
  address?: Maybe<Array<ValidationError>>;
  catalog?: Maybe<Array<ValidationError>>;
  customizeBy?: Maybe<Array<ValidationError>>;
  giftNotes?: Maybe<Array<ValidationError>>;
  quantity?: Maybe<Array<ValidationError>>;
  soldOutItem?: Maybe<Array<ValidationError>>;
  status?: Maybe<Array<ValidationError>>;
};

export type CartValidationError = {
  __typename?: 'CartValidationError';
  validation?: Maybe<CartValidation>;
};

export type CheckoutCartError = {
  __typename?: 'CheckoutCartError';
  cartValidation?: Maybe<CartValidationError>;
  inactiveCatalog?: Maybe<Scalars['String']['output']>;
  invalidCart?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckoutCartResult = Cart | CheckoutCartError;

export type CreateCartDeliveryInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItems?: InputMaybe<Array<CreateCartDeliveryLineItemInput>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCartDeliveryLineItemInput = {
  price: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  variant?: InputMaybe<Scalars['JSON']['input']>;
  variantId: Scalars['Int']['input'];
};

export type CreateCartInput = {
  /** Must be a Sunday */
  deliveryWeek?: InputMaybe<Scalars['Date']['input']>;
  orderOn?: InputMaybe<Scalars['Date']['input']>;
  planLogicalId?: InputMaybe<Scalars['String']['input']>;
  populationCriteria?: InputMaybe<CartPopulationCriteriaInput>;
  /** Captures all used query params on cart creation */
  queryParams?: InputMaybe<Scalars['JSON']['input']>;
  recipientName: Scalars['String']['input'];
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFunnelDataInput = {
  creditCardId?: InputMaybe<Scalars['Int']['input']>;
  dietaryTemplateId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  filters?: Scalars['JSON']['input'];
  mealSize: Scalars['String']['input'];
  name: Scalars['String']['input'];
  params?: Scalars['JSON']['input'];
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreditCardV2 = {
  __typename?: 'CreditCardV2';
  displayName: Scalars['String']['output'];
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  /** The payment process network (e.g. Visa, MasterCard) */
  network: Scalars['String']['output'];
};

export enum DeliveryType {
  Local = 'Local',
  Shipping = 'Shipping'
}

export type Designer = {
  __typename?: 'Designer';
  name: Scalars['String']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DraftCart = {
  __typename?: 'DraftCart';
  cartDeliveries: Array<DraftCartDelivery>;
  cartError?: Maybe<DraftCartError>;
  cartLedger: DraftCartLedger;
  deliveryDates: Array<Scalars['Date']['output']>;
  discount?: Maybe<Discount>;
};

/** A cart delivery that does not exist in the database */
export type DraftCartDelivery = {
  __typename?: 'DraftCartDelivery';
  deliveryDate: Scalars['Date']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  estimatedTransitTime?: Maybe<Scalars['Int']['output']>;
  lineItems: Array<DraftCartDeliveryLineItem>;
};

export type DraftCartDeliveryLineItem = {
  __typename?: 'DraftCartDeliveryLineItem';
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  /** Catalog variant data pulled from cache or ecomm-catalogs */
  variant?: Maybe<Scalars['JSON']['output']>;
  variantId: Scalars['Int']['output'];
};

export type DraftCartError = {
  __typename?: 'DraftCartError';
  validation: DraftCartValidation;
};

export type DraftCartLedger = {
  __typename?: 'DraftCartLedger';
  creditTotal: Scalars['Int']['output'];
  deliveryTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  precreditTotal: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
};

export type DraftCartValidation = {
  __typename?: 'DraftCartValidation';
  catalog?: Maybe<Array<ValidationError>>;
  quantity?: Maybe<Array<ValidationError>>;
  soldOutItem?: Maybe<Array<ValidationError>>;
};

export type EvaluateDraftCartDeliveryInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItems: Array<EvaluateDraftCartLineItemInput>;
};

export type EvaluateDraftCartInput = {
  cartDeliveries: Array<EvaluateDraftCartDeliveryInput>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
};

export type EvaluateDraftCartLineItemInput = {
  /** Used as a mechanism to detect new items being incremented, and validate soldOut items to filter them out and not evaluate them (as of 04/23) */
  new?: InputMaybe<Scalars['Boolean']['input']>;
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type MacroNutrients = {
  __typename?: 'MacroNutrients';
  caloriesInG: Scalars['Float']['output'];
  /** @deprecated Should have been using total carbs in G all along */
  netCarbsInG?: Maybe<Scalars['Float']['output']>;
  proteinInG: Scalars['Float']['output'];
  totalCarbsInG: Scalars['Float']['output'];
  totalFatInG: Scalars['Float']['output'];
};

export type MealQuantityByMealTypeInput = {
  breakfast: Scalars['Float']['input'];
  lunchDinner: Scalars['Float']['input'];
};

export type MealSize = {
  __typename?: 'MealSize';
  displayName: Scalars['String']['output'];
};

export type MetroDataInput = {
  additionalDeliveryFeeCents: Scalars['Int']['input'];
  allowedZips: Array<Scalars['String']['input']>;
  chargeOn: Scalars['String']['input'];
  customizeBy: Scalars['String']['input'];
  deliveryDates: Array<Scalars['String']['input']>;
  deliveryFeeCents: Scalars['Int']['input'];
  deliveryType: Scalars['String']['input'];
  /** Must be a Sunday */
  deliveryWeek: Scalars['Date']['input'];
  estimatedTransitTime?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  metroStates: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable: Scalars['Boolean']['input'];
  prices: Array<Prices>;
  regionalShipping: Scalars['Boolean']['input'];
  sustainableZips: Array<Scalars['String']['input']>;
  ttl: Scalars['Int']['input'];
  validMealQuantities: Array<Scalars['Int']['input']>;
};

export type MetroV2 = {
  __typename?: 'MetroV2';
  /** The deadline for customizing the current week */
  currentModifyDeadline: Scalars['DateTime']['output'];
  /** The value of `metros.id` in the rails app. */
  legacyRailsId: Scalars['Int']['output'];
  /** Monday and Thursday dates, which are recognized by the legacy rails app. */
  legacySystemShoppableDeliveryDates: Array<Scalars['Date']['output']>;
  /** The currently-shoppable delivery dates for the metro */
  shoppableDeliveryDates: Array<Scalars['Date']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCodeToCartV2: CartResult;
  addVariantToCartDeliveryV2: CartDeliveryResult;
  /** Remove all catalog and variant cache entries from the cache */
  bustCatalogCache: Scalars['Boolean']['output'];
  /** Remove all variant entries from and refresh the delivery containers in the delivery container service in-memory cache */
  bustDeliveryContainerServiceCache: Scalars['Boolean']['output'];
  cancelSubscriptionV2: SubscriptionEntityV2;
  checkoutCart: CheckoutCartResult;
  createCart: Cart;
  createCartInternal: CartResult;
  emptyCartDeliveryV2: CartDeliveryResult;
  /** Validates and prices a draft cart without persisting it. Pricing is dependent upon the currently-authenticated user. If any of the cart validations fail, a draft cart object is guaranteed to be returned with cart deliveries for supported delivery dates */
  evaluateDraftCart: DraftCart;
  processCart: ProcessCartResult;
  processPaymentFailure: ProcessCartResult;
  processPaymentSuccess: ProcessCartResult;
  removeCodeFromCart: CartResult;
  removeVariantFromCartDeliveryV2: CartDeliveryResult;
  repriceCart: Cart;
  repriceCartInternal: CartResult;
  repriceCartV2: CartResult;
  repriceCartsByIdInternal: Array<CartResult>;
  updateCartDelivery: CartDelivery;
  updateCartDeliveryV2: CartDeliveryResult;
  updateCartV2: CartResult;
  updateCartV2Internal: CartResult;
  updatePaymentMethod: SubscriptionEntityV2;
  updateSubscriptionLocation: SubscriptionEntityV2;
};


export type MutationAddCodeToCartV2Args = {
  code: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationAddVariantToCartDeliveryV2Args = {
  cartDeliveryId: Scalars['Int']['input'];
  cartUUID: Scalars['UUID']['input'];
  variantInput: AddVariantToCartDeliveryInput;
};


export type MutationCancelSubscriptionV2Args = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<SubscriptionCancellationReason>;
  reason?: InputMaybe<Scalars['String']['input']>;
  userComments?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};


export type MutationCheckoutCartArgs = {
  giftNotes?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};


export type MutationCreateCartArgs = {
  cartData: CreateCartInput;
  funnelData: CreateFunnelDataInput;
};


export type MutationCreateCartInternalArgs = {
  cartData: CartDataInternalInput;
  cartDeliveryData: Array<CreateCartDeliveryInput>;
  discountData?: InputMaybe<PriceCartDiscount>;
  funnelData: CreateFunnelDataInput;
  metroData: MetroDataInput;
  overwriteExisting?: Scalars['Boolean']['input'];
  tenantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationEmptyCartDeliveryV2Args = {
  cartDeliveryId: Scalars['Int']['input'];
  cartUUID: Scalars['UUID']['input'];
};


export type MutationEvaluateDraftCartArgs = {
  draftCart: EvaluateDraftCartInput;
  recurringSubscription: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};


export type MutationProcessCartArgs = {
  legacyOrderId: Scalars['Int']['input'];
  orderOn: Scalars['String']['input'];
};


export type MutationProcessPaymentFailureArgs = {
  failureReason: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationProcessPaymentSuccessArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRemoveCodeFromCartArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRemoveVariantFromCartDeliveryV2Args = {
  cartDeliveryId: Scalars['Int']['input'];
  cartUUID: Scalars['UUID']['input'];
  variantInput: RemoveVariantInput;
};


export type MutationRepriceCartArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRepriceCartInternalArgs = {
  deliveryWeek: Scalars['Date']['input'];
  legacyOrderId: Scalars['Int']['input'];
};


export type MutationRepriceCartV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRepriceCartsByIdInternalArgs = {
  cartIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateCartDeliveryArgs = {
  deliveryData: UpdateCartDeliveryInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCartDeliveryV2Args = {
  deliveryData: UpdateCartDeliveryInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCartV2Args = {
  cartData?: InputMaybe<UpdateCartInput>;
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateCartV2InternalArgs = {
  cartData?: InputMaybe<UpdateCartInput>;
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  userId: Scalars['Int']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdatePaymentMethodArgs = {
  paymentMethodId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationUpdateSubscriptionLocationArgs = {
  input: UpdateSubscriptionLocationInput;
};

export type NutritionalFactsInput = {
  addedSugarInG?: InputMaybe<RangeInput>;
  calciumInMg?: InputMaybe<RangeInput>;
  caloriesInKcal?: InputMaybe<RangeInput>;
  cholesterolInMg?: InputMaybe<RangeInput>;
  dietaryFiberInG?: InputMaybe<RangeInput>;
  ironInMg?: InputMaybe<RangeInput>;
  netCarbsInG?: InputMaybe<RangeInput>;
  potassiumInMg?: InputMaybe<RangeInput>;
  proteinInG?: InputMaybe<RangeInput>;
  saturatedFatInG?: InputMaybe<RangeInput>;
  servingSizeInOz?: InputMaybe<RangeInput>;
  sodiumInMg?: InputMaybe<RangeInput>;
  sugarsInG?: InputMaybe<RangeInput>;
  totalCarbsInG?: InputMaybe<RangeInput>;
  totalFatInG?: InputMaybe<RangeInput>;
  vitaminDInMcg?: InputMaybe<RangeInput>;
};

export type Order = {
  __typename?: 'Order';
  cart: Cart;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

/** Representation of a processed cart delivery */
export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  trackingId?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type PayPalV2 = {
  __typename?: 'PayPalV2';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type PaymentMethodV2 = ApplePayV2 | CreditCardV2 | PayPalV2;

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['Int']['output'];
  logicalId: Scalars['String']['output'];
};

export type PriceCartDelivery = {
  cartDeliveryLineItems: Array<PriceCartDeliveryLineItem>;
  deliveryDate: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};

export type PriceCartDeliveryLineItem = {
  price: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type PriceCartDiscount = {
  active: Scalars['Boolean']['input'];
  amount: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  d1MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  d2MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  freeShipping: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  lockedAt?: InputMaybe<Scalars['String']['input']>;
  maxRedemptionsPerEmail?: InputMaybe<Scalars['Int']['input']>;
  newCustomerOnly: Scalars['Boolean']['input'];
  tenantId: Scalars['Int']['input'];
  totalMealMinimum?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  weeksToApply?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceCartInput = {
  cartDeliveries: Array<PriceCartDelivery>;
  discount?: InputMaybe<PriceCartDiscount>;
  funnelData: PriceFunnelData;
  tenantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type PriceFunnelData = {
  mealSize: Scalars['String']['input'];
  metro: PriceMetro;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type PriceMetro = {
  deliveryType: DeliveryType;
  id: Scalars['Int']['input'];
  regionalShipping: Scalars['Boolean']['input'];
  shippingCosts: Scalars['JSON']['input'];
};

export type Prices = {
  calories: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type ProcessCartResult = Cart | CartError;

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  designer: Designer;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  cart?: Maybe<Cart>;
  cartDelivery: CartDelivery;
  cartInternal?: Maybe<Cart>;
  dashboardSubscriptionsV2: Array<SubscriptionEntityV2>;
  priceCart: CartLedger;
  subscriptionV2: SubscriptionEntityV2;
  subscriptionsV2: Array<SubscriptionEntityV2>;
};


export type QueryCartArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCartDeliveryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCartInternalArgs = {
  deliveryWeek: Scalars['Date']['input'];
  legacyOrderId: Scalars['Int']['input'];
};


export type QueryPriceCartArgs = {
  accountData: AccountData;
  cartData: PriceCartInput;
};


export type QuerySubscriptionV2Args = {
  uuid: Scalars['UUID']['input'];
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: Scalars['Float']['input'];
};

export type RemoveVariantInput = {
  quantity: Scalars['Int']['input'];
  /** ID of the Variant in the ecomm-catalog-service */
  variantId: Scalars['Int']['input'];
};

export type SubscriptionCancellation = {
  __typename?: 'SubscriptionCancellation';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
};

export enum SubscriptionCancellationReason {
  BillingIssues = 'BILLING_ISSUES',
  DeliveryIssues = 'DELIVERY_ISSUES',
  MealPricing = 'MEAL_PRICING',
  MealQuality = 'MEAL_QUALITY',
  MealVariety = 'MEAL_VARIETY',
  Other = 'OTHER'
}

export type SubscriptionDeliveryV2 = {
  __typename?: 'SubscriptionDeliveryV2';
  day: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type SubscriptionEntityV2 = {
  __typename?: 'SubscriptionEntityV2';
  cancellation?: Maybe<SubscriptionCancellation>;
  carts: Array<Cart>;
  displayName: Scalars['String']['output'];
  endWeek?: Maybe<Scalars['Date']['output']>;
  legacyOrderId?: Maybe<Scalars['Float']['output']>;
  location: SubscriptionLocationV2;
  mealsPerWeek: Scalars['Int']['output'];
  metro: MetroV2;
  orders: Array<Order>;
  /** JSON map of ISO string date of the Sunday at the head of a delivery week to boolean indicating whether or not there is a pause for that delivery week */
  pauses: Scalars['JSONObject']['output'];
  paymentMethod?: Maybe<PaymentMethodV2>;
  startWeek: Scalars['Date']['output'];
  /** Should send `ACTIVE` or `INACTIVE` */
  status: Scalars['String']['output'];
  subscriptionDeliveries: Array<SubscriptionDeliveryV2>;
  uuid: Scalars['UUID']['output'];
};


export type SubscriptionEntityV2CartsArgs = {
  excludeProcessed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionEntityV2OrdersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<CartStatus>>;
};


export type SubscriptionEntityV2PausesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionLocationV2 = {
  __typename?: 'SubscriptionLocationV2';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  dropoffLocation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type UpdateCartDeliveryInput = {
  deliveryDate?: InputMaybe<Scalars['Date']['input']>;
  lineItems?: InputMaybe<Array<CreateCartDeliveryLineItemInput>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCartInput = {
  /** Overwrites the existing cart deliveries. Delivery dates should correspond to the eligible delivery dates found on the cart. If any dates are omitted from this input array, those deliveries will be created without any line items. A zero-length array results in no operation. */
  cartDeliveries?: InputMaybe<Array<CartDeliveryInput>>;
  orderOn?: InputMaybe<Scalars['Date']['input']>;
  planLogicalId?: InputMaybe<Scalars['String']['input']>;
  populationCriteria?: InputMaybe<CartPopulationCriteriaInput>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunnelDataInput = {
  creditCardId?: InputMaybe<Scalars['Int']['input']>;
  dietaryTemplateId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  mealSize?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionLocationInput = {
  /** Location must belong to the same storefront currently associated with the subscription via the metroId */
  locationId: Scalars['Int']['input'];
  subscriptionUuid: Scalars['UUID']['input'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  deliveryId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

export type CreateCartMutationVariables = Exact<{
  funnelData: CreateFunnelDataInput;
  cartData: CreateCartInput;
}>;


export type CreateCartMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', uuid: any, funnelData: any } };

export type CreateAndReturnCartMutationVariables = Exact<{
  funnelData: CreateFunnelDataInput;
  cartData: CreateCartInput;
}>;


export type CreateAndReturnCartMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, metroId: number, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null } };

export type CreateAndReturnCartWithPreviewDiscountMutationVariables = Exact<{
  funnelData: CreateFunnelDataInput;
  cartData: CreateCartInput;
  previewFunnelDiscountCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAndReturnCartWithPreviewDiscountMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, metroId: number, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null } };

export type UpdateCartWithPreviewDiscountMutationVariables = Exact<{
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  cartData?: InputMaybe<UpdateCartInput>;
  uuid: Scalars['UUID']['input'];
  previewFunnelDiscountCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCartWithPreviewDiscountMutation = { __typename?: 'Mutation', updateCart:
    | { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, metroId: number, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type UpdateCartMutationVariables = Exact<{
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  cartData?: InputMaybe<UpdateCartInput>;
  uuid: Scalars['UUID']['input'];
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', updateCart:
    | { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, metroId: number, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type AddVariantToCartDeliveryMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
  variantInput: AddVariantToCartDeliveryInput;
}>;


export type AddVariantToCartDeliveryMutation = { __typename?: 'Mutation', addVariantToCartDelivery:
    | { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, funnelData: any, metroId: number, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type AddVariantToCartDeliveryWithPreviewDiscountMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
  variantInput: AddVariantToCartDeliveryInput;
  previewFunnelDiscountCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddVariantToCartDeliveryWithPreviewDiscountMutation = { __typename?: 'Mutation', addVariantToCartDelivery:
    | { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, funnelData: any, metroId: number, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type RemoveVariantFromCartDeliveryMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
  variantInput: RemoveVariantInput;
}>;


export type RemoveVariantFromCartDeliveryMutation = { __typename?: 'Mutation', removeVariantFromCartDelivery:
    | { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, funnelData: any, metroId: number, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, creditTotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null }
   };

export type RemoveVariantFromCartDeliveryWithPreviewDiscountMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
  variantInput: RemoveVariantInput;
  previewFunnelDiscountCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveVariantFromCartDeliveryWithPreviewDiscountMutation = { __typename?: 'Mutation', removeVariantFromCartDelivery:
    | { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, funnelData: any, metroId: number, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, creditTotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null }
   };

export type AddCodeToCartMutationVariables = Exact<{
  code: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
}>;


export type AddCodeToCartMutation = { __typename?: 'Mutation', addCodeToCart:
    | { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, funnelData: any, metroId: number, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, discountErrors?: Array<string> | null, appliedCodeType?: string | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, creditTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type RemoveCodeFromCartMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type RemoveCodeFromCartMutation = { __typename?: 'Mutation', removeCodeFromCart:
    | { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, funnelData: any, metroId: number, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, creditTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type RepriceCartMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type RepriceCartMutation = { __typename?: 'Mutation', repriceCart:
    | { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, funnelData: any, status: CartStatus, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, creditTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type UpdateCartDeliveryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  deliveryData: UpdateCartDeliveryInput;
}>;


export type UpdateCartDeliveryMutation = { __typename?: 'Mutation', updateCartDelivery:
    | { __typename?: 'CartDelivery', id: number, status: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type EvaluateDraftCartMutationVariables = Exact<{
  draftCart: EvaluateDraftCartInput;
  zip: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  recurringSubscription: Scalars['Boolean']['input'];
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EvaluateDraftCartMutation = { __typename?: 'Mutation', evaluateDraftCart: { __typename?: 'DraftCart', deliveryDates: Array<any>, discount?: { __typename?: 'Discount', code: string, amount: number, type: string } | null, cartDeliveries: Array<{ __typename?: 'DraftCartDelivery', estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'DraftCartDeliveryLineItem', variantId: number, quantity: number, price: number, variant?: any | null }> }>, cartLedger: { __typename?: 'DraftCartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, precreditTotal: number, grandTotal: number }, cartError?: { __typename?: 'DraftCartError', validation: { __typename?: 'DraftCartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } } | null } };

export type UpdateCartV2MutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  cartData: UpdateCartInput;
}>;


export type UpdateCartV2Mutation = { __typename?: 'Mutation', updateCartV2:
    | { __typename: 'Cart', uuid: any, userId?: number | null, legacyOrderId?: number | null, status: CartStatus, funnelData: any, deliveryDates: any, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, precreditTotal: number, grandTotal: number } | null }
    | { __typename: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null }
   };

export type EmptyCartDeliveryMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
}>;


export type EmptyCartDeliveryMutation = { __typename?: 'Mutation', emptyCartDelivery:
    | { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, funnelData: any, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, creditTotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } }
    | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null }
   };

export type GetCartByIdQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetCartByIdQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, status: CartStatus, createdAt: any, legacyOrderId?: number | null, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, funnelData: any, metroId: number, createdFromPlan?: { __typename?: 'Plan', id: number, logicalId: string } | null, subscription?: { __typename?: 'SubscriptionEntityV2', uuid: any } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, deliveryDate: any, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } | null };

export type GetCartByIdWithPreviewFunnelDiscountQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  previewFunnelDiscountCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCartByIdWithPreviewFunnelDiscountQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, status: CartStatus, createdAt: any, legacyOrderId?: number | null, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, funnelData: any, metroId: number, createdFromPlan?: { __typename?: 'Plan', id: number, logicalId: string } | null, subscription?: { __typename?: 'SubscriptionEntityV2', uuid: any } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, deliveryDate: any, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } | null };

export type GetCheckoutCartV2ByIdQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetCheckoutCartV2ByIdQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', uuid: any, recipientName: string, recipientId?: number | null, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, status: CartStatus, createdAt: any, legacyOrderId?: number | null, tenantEligibilityConfigLogicalId: string, modifiedDuringFunnel: boolean, funnelData: any, createdFromPlan?: { __typename?: 'Plan', id: number, logicalId: string } | null, subscription?: { __typename?: 'SubscriptionEntityV2', uuid: any } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, deliveryDate: any, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } | null };

export type AllCartFieldsFragment = { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, metroId: number, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null };

export type AllCartFieldsWithPreviewDiscountFragment = { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, metroId: number, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, modifiedDuringFunnel: boolean, createdFromPersonalizedPlan: boolean, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null };

export type CheckoutCartMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  giftNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutCartMutation = { __typename?: 'Mutation', checkoutCart:
    | { __typename: 'Cart', uuid: any, legacyOrderId?: number | null, subscription?: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null } | null, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number } | null, discount?: { __typename?: 'Discount', code: string } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', price: number, quantity: number, variant?: any | null }> }> }
    | { __typename: 'CheckoutCartError', inactiveCatalog?: string | null, invalidCart?: boolean | null, cartValidation?: { __typename?: 'CartValidationError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, address?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null }
   };

export type SubMgmtFieldsFragment = { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, paymentMethod?:
    | { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string }
    | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string }
    | { __typename?: 'PayPalV2', displayName: string, email: string }
   | null };

export type UpdatePaymentMethodV2MutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  paymentMethodId: Scalars['Int']['input'];
}>;


export type UpdatePaymentMethodV2Mutation = { __typename?: 'Mutation', updatePaymentMethod: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, paymentMethod?:
      | { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string }
      | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string }
      | { __typename?: 'PayPalV2', displayName: string, email: string }
     | null } };

export type CancelSubscriptionMutationVariables = Exact<{
  subId: Scalars['UUID']['input'];
  cancellationReason?: InputMaybe<SubscriptionCancellationReason>;
  userComments?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscriptionV2: { __typename?: 'SubscriptionEntityV2', cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null } };

export type GetSubscriptionUuiDsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionUuiDsV2Query = { __typename?: 'Query', dashboardSubscriptionsV2: Array<{ __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, status: string, displayName: string, carts: Array<{ __typename?: 'Cart', uuid: any }> }> };

export type GetSubscriptionV2ByUuidQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetSubscriptionV2ByUuidQuery = { __typename?: 'Query', subscriptionV2: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, paymentMethod?:
      | { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string }
      | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string }
      | { __typename?: 'PayPalV2', displayName: string, email: string }
     | null } };
